import { render, staticRenderFns } from "./TechData.vue?vue&type=template&id=7a21d405&scoped=true"
import script from "./TechData.vue?vue&type=script&lang=js"
export * from "./TechData.vue?vue&type=script&lang=js"
import style0 from "./TechData.vue?vue&type=style&index=0&id=7a21d405&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a21d405",
  null
  
)

export default component.exports